import React from 'react';

export type ViewMode = 'grid' | 'list';

interface Props {
  view: ViewMode;
  onChange: (v: ViewMode) => void;
}

const ViewToggle: React.FC<Props> = ({ view, onChange }) => (
  <div className="lib-view-toggle">
    <button
      className={`lib-view-btn${view === 'grid' ? ' lib-view-btn--active' : ''}`}
      onClick={() => onChange('grid')}
      title="Dạng lưới"
    >
      <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <rect x="1" y="1" width="6" height="6" rx="1.2" fill="currentColor" />
        <rect x="9" y="1" width="6" height="6" rx="1.2" fill="currentColor" />
        <rect x="1" y="9" width="6" height="6" rx="1.2" fill="currentColor" />
        <rect x="9" y="9" width="6" height="6" rx="1.2" fill="currentColor" />
      </svg>
    </button>
    <button
      className={`lib-view-btn${view === 'list' ? ' lib-view-btn--active' : ''}`}
      onClick={() => onChange('list')}
      title="Dạng danh sách"
    >
      <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <rect x="1" y="2" width="14" height="2" rx="1" fill="currentColor" />
        <rect x="1" y="7" width="14" height="2" rx="1" fill="currentColor" />
        <rect x="1" y="12" width="14" height="2" rx="1" fill="currentColor" />
      </svg>
    </button>
  </div>
);

export default ViewToggle;
